import React from 'react';
import MainLayoutHome from '../layout/MainLayoutHome';
import Tiffany from '../components/Tiffany';

const TiffanyPage = () => {
  return (
    <MainLayoutHome>
        <Tiffany/>
    </MainLayoutHome>
  )
}

export default TiffanyPage